(function () {
  'use strict';

  angular
    .module('itecAdministracio.rols.main.submain.edit')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('rols.main.submain.edit', {
        url: '/edit',
         params: {
          isNew : false
        },
      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosRolsHeaderSubmenuLinksValue){
                return permisosRolsHeaderSubmenuLinksValue;
              }
            }
          },
          'content@rols.main.submain': {
            templateUrl: 'rols/main/edit/edit.tpl.html',
            controller: 'RolsMainEditCtrl',
            controllerAs: 'ctrl'  ,
            resolve: {
              llistaproductes: function(ProducteFactory) {
                return ProducteFactory.getProductesEntitats().catch(function(){});
              },
              llistaentitats:function(EntitatFactory) {
                return EntitatFactory.getAll().catch(function(){});
              }
            }
          }
        }
      });
  }
}());
